type NameTranslation = { locale: string; name: string };

/**
 * Resolves a locale-specific name from nameTranslations (set in admin).
 * Returns null if no match found — caller should apply its own fallback.
 */
export function resolveMethodName(
  nameTranslations: NameTranslation[] | undefined,
  locale: string,
): string | null {
  const hit = (nameTranslations ?? []).find((t) => t.locale === locale);
  return hit?.name ?? null;
}
